var samsung_AA64_50236A = {
    name: "AA64_50236A",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,223,218,170,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,239,214,170,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,183,246,170,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,215,238,170,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,247,213,170,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,187,245,170,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,219,237,170,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,235,235,170,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,181,251,170,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,213,247,170,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,189,245,106,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,171,254,170,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,173,253,170,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,221,237,106,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,251,213,106,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,218,246,234,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,170,255,170,136],
        },
        {
            function: "PSize",
            name: "PSize",
            icon: "PSize",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,213,93,250,136],
        },
        {
            // function: "KEY_TV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,173,126,234,136],
        },
        {
            function: "KEY_VIDEO",
            name: "KEY_VIDEO",
            icon: "KEY_VIDEO",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,191,234,170,136],
        },
        {
            function: "Display",
            name: "Display",
            icon: "Display",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,170,191,234,136],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,175,250,170,136],
        },
        {
            function: "Turbo",
            name: "Turbo",
            icon: "Turbo",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,174,253,106,136],
        },
        {
            function: "SMenu",
            name: "SMenu",
            icon: "SMenu",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,237,235,106,136],
        },
        {
            function: "SSTD",
            name: "SSTD",
            icon: "SSTD",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,182,251,106,136],
        },
        {
            function: "PSTD",
            name: "PSTD",
            icon: "PSTD",
            command: [68,0,4,31,2,65,2,31,2,145,6,252,17,45,18,31,2,109,178,42,253,95,214,247,106,136],
        },
    ]
}
export default samsung_AA64_50236A